<!-- Novo pedir delivery -->
<div *ngIf="isNewHomePedirDelivery" class="new-login-wrapper">

  <div class="new-login-header">
    <button class="new-login-close-button" (click)="goBack()">
      <img src="assets/icon/login-close.svg" alt="" />
    </button>
  </div>

  <div class="new-login-body">

    <div class="new-login-intro-container">
      <div class="new-login-intro-icon-wrapper">
        <span class="new-login-intro-icon"></span>
      </div>
      <h2 class="new-login-intro-title">Acesse ou crie sua conta</h2>
      <p class="new-login-intro-subtitle">Digite seu email e senha para entrar</p>
    </div>

    <div class="new-login-form-container">

      <div class="new-login-field-container">
        <label class="new-login-field-label">Email</label>
        <div class="new-login-field-input-wrapper">
          <span class="new-login-field-icon new-login-field-icon--mail"></span>
          <input
            type="email"
            placeholder="seu@email.com"
            class="new-login-field-input"
            [(ngModel)]="email"
            (keyup.enter)="loginByEmail()"
            autocomplete="off"
            inputmode="email"
          />
        </div>
      </div>

      <div class="new-login-field-container">
        <label class="new-login-field-label">Senha</label>
        <div class="new-login-field-input-wrapper">
          <span class="new-login-field-icon new-login-field-icon--lock"></span>
          <input
            [type]="showPassword ? 'text' : 'password'"
            placeholder="••••••••"
            class="new-login-field-input"
            [(ngModel)]="password"
            (keyup.enter)="loginByEmail()"
            autocomplete="off"
          />
          <button class="new-login-field-eye-button" (click)="showPassword = !showPassword">
            <span *ngIf="!showPassword" class="new-login-field-eye-icon new-login-field-eye-icon--off"></span>
            <span *ngIf="showPassword" class="new-login-field-eye-icon new-login-field-eye-icon--on"></span>
          </button>
        </div>
        <a class="new-login-field-forgot-password" (click)="goToForgotPassword()">Esqueci minha senha</a>
      </div>

      <div id="recaptcha-v2" class="new-login-recaptcha"></div>

      <button class="new-login-primary-button" (click)="loginByEmail()">Entrar</button>

      <div class="new-login-divider">
        <span class="new-login-divider-line"></span>
        <span class="new-login-divider-text">ou</span>
        <span class="new-login-divider-line"></span>
      </div>

      <button class="new-login-google-button" (click)="loginWithGoogle()">
        <img src="assets/icon/icon-google.svg" alt="Google" class="new-login-google-button-icon" />
        Entrar com Google
      </button>

      <button class="new-login-primary-button" (click)="goToRegister()">Criar conta com Email</button>

    </div>
  </div>

</div>

<!-- Antigo pedir delivery -->
<ng-container *ngIf="!isNewHomePedirDelivery">
  <ion-header>
    <ion-toolbar color="danger">
      <div class="container-header">
        <ion-buttons>
          <ion-button (click)="goBack()">
            <ion-icon name="chevron-back-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-title class="text-toolbar" translate>Access or create your account</ion-title>
      </div>
    </ion-toolbar>
  </ion-header>

  <ion-content class="content-color">
    <section class="body-login">
      <div class="container">
        <div class="center-div-login">
          <input autocomplete="off" data-cy='inputLoginEmail' inputmode="email" placeholder="E-mail" type="text" class="input-email" name="email" [(ngModel)]="email" (keyup.enter)="loginByEmail()">
          <input autocomplete="off" data-cy='inputLoginPassword' placeholder="{{ 'Password' | translate }}" type="password" name="password" [(ngModel)]="password" (keyup.enter)="loginByEmail()">
        </div>
        <div id="recaptcha-v2" class="new-login-recaptcha"></div>

        <div class="entry-buttons">
          <ion-button data-cy="btnUserLogin" color="danger" expand="block" class="button-login" strong="true" mode="ios" translate (click)="loginByEmail()">Login</ion-button>
          <div class="center-div-forgot-password">
            <a color="Dark" class="forgot-password" translate (click)="goToForgotPassword()">I forgot my password</a>
            <h6 class="or" translate>or</h6>
          </div>
          <div>
            <!-- <ion-button expand="block" class="button-facebook" strong="true" mode="ios" translate (click)="loginWithFacebook()">
              Login with Facebook
            </ion-button> -->
            <ion-button data-cy="btnUserLoginWithGoogle" expand="block" class="button-google" (click)="loginWithGoogle()" strong="true" mode="ios" translate>
              Login with Google
            </ion-button>
            <ion-button color="danger" expand="block" class="button-login" strong="true" mode="ios" translate (click)="goToRegister()">Create account with E-mail</ion-button>
          </div>
        </div>
      </div>
    </section>
  </ion-content>
</ng-container>
